import { TabBar, useTabs } from "@amzn/stencil-react-components/tabs";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { PLATFORMS } from "@/services/device-options/device-options.types";
import type { Platform } from "@/services/device-options/device-options.types";

const PLATFORM_TABS = PLATFORMS.map((value) => ({
  value,
  label: getString(`replacement.platform.${value}`),
}));

export interface PlatformTabsProps {
  activePlatform: Platform;
  onSelect: (platform: Platform) => void;
}

export const PlatformTabs: FC<PlatformTabsProps> = ({ activePlatform, onSelect }) => {
  const { tabBarProps } = useTabs({
    tabs: PLATFORM_TABS,
    defaultTab: activePlatform,
    onTabSelect: (value) => onSelect(value as Platform),
  });

  return <TabBar {...tabBarProps} selectedTab={activePlatform} />;
};
